import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	canRefresh: true,
	errorMessage: null,
	integrationData: null,
	isLoading: false,
};

export default function oauthReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.SAVE_AUTH_CODE:
			return { ...state, isLoading: true, errorMessage: null };
		case ActionTypes.SAVE_AUTH_CODE_SUCCESS:
			return { ...state, isLoading: false, integrationData: action.payload, errorMessage: null };
		case ActionTypes.SAVE_AUTH_CODE_FAILURE:
			return { ...state, isLoading: false, errorMessage: action.payload };
		case ActionTypes.REFRESH_ACCESS_TOKEN:
			return { ...state, isLoading: true, errorMessage: null };
		case ActionTypes.REFRESH_ACCESS_TOKEN_SUCCESS:
			return {
				...state,
				isLoading: false,
				canRefresh: false,
				integrationData: action.payload,
				errorMessage: null,
			};
		case ActionTypes.REFRESH_ACCESS_TOKEN_FAILURE:
			return { ...state, isLoading: false, errorMessage: action.payload };
		case ActionTypes.CAN_REFRESH:
			return { ...state, canRefresh: true };
		case ActionTypes.CANNOT_REFRESH:
			return { ...state, canRefresh: false };
		default:
			return state;
	}
}
